import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import useStyles from "./useStyles";

const PlayerContainer = ({ inviteTheme, children, vertical, bordered }) => {
  const classes = useStyles({ inviteTheme });
  return (
    <div className={clsx({ [classes.vertical]: vertical })}>
      <div className={clsx(classes.root, { [classes.rootBordered]: bordered })}>
        <div data-testid="commonPlayer-container" className={classes.player}>
          {children}
        </div>
      </div>
    </div>
  );
};

PlayerContainer.propTypes = {
  inviteTheme: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  vertical: PropTypes.bool,
  bordered: PropTypes.bool,
};

export default PlayerContainer;
